import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ChargesTable } from '~/app/components/session/ChargesTable/ChargesTable';

const { Paragraph, Title } = Typography;

export function SessionHome() {
  const { t } = useTranslation('sessions');

  return (
    <Space orientation="vertical" size={24} style={{ width: '100%' }}>
      <div>
        <Title level={2} style={{ marginBottom: 8 }}>
          {t('title')}
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          {t('chargesHelp')}
        </Paragraph>
      </div>
      <ChargesTable />
    </Space>
  );
}
